"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./ImageGallery.scss");
var _ImageGalleryMethods = require("./ImageGalleryMethods");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// let Flickity;
// if (typeof window !== "undefined") {
//   Flickity = require("flickity")
//   require("flickity-as-nav-for")
// }

const ImageGallery = _ref => {
  let {
    content,
    paddingClass,
    type,
    contentfulId,
    sliderQty = 3
  } = _ref;
  const wrapper = (0, _react.useRef)();
  const thumbnailWrapper = (0, _react.useRef)();
  const lightboxMain = (0, _react.useRef)();
  const lightboxNav = (0, _react.useRef)();
  const lightboxNavHorz = (0, _react.useRef)();
  const [currentImage, setCurrentImage] = (0, _react.useState)(content?.images && content?.images[0]);
  const [currentThumb, setCurrentThumb] = (0, _react.useState)(0);
  const [showLightbox, setShowLightbox] = (0, _react.useState)(false);
  const noButton = true;
  const updateNavChildren = lightboxNavInstance => {
    lightboxNavInstance?.slider?.childNodes?.forEach(child => {
      child.style.position = "relative";
      child.ariaHidden = "false";
    });
  };

  // useEffect(() => {
  //   if(lightboxMain?.current){
  //     const lightboxMainParams = {
  //       cellAlign: 'center',
  //       pageDots: false,
  //       contain: true,
  //       adaptiveHeight: true,
  //       draggable: false,
  //       fades: true,
  //       setGallerySize: false
  //     }
  //     const lightboxFlickity = new Flickity(lightboxMain.current, lightboxMainParams);
  //   }
  //   if(lightboxNav?.current){
  //     const lightboxNavParams = {
  //       contain: true,
  //       wrapAround: true,
  //       cellAlign: 'left',
  //       pageDots: false,
  //       prevNextButtons: false,
  //       draggable: false,
  //       groupCells: "100%"
  //     };
  //     const lightboxNavFlickity = new Flickity(lightboxNav.current, lightboxNavParams);
  //     const lightboxNavFlickityElem = '.ter-image-gallery__lightbox-nav';
  //     if(lightboxNavFlickityElem) updateNavChildren(lightboxNavFlickity);

  //     const lightboxNavParamsHorz = {
  //       contain: true,
  //       wrapAround: true,
  //       cellAlign: 'left',
  //       pageDots: false,
  //       prevNextButtons: false,
  //       draggable: false,
  //       groupCells: "100%"
  //     };

  //     const lightboxNavFlickityHorz = new Flickity(lightboxNavHorz.current, lightboxNavParamsHorz);
  //     if(lightboxNavFlickityHorz) updateNavChildren(lightboxNavFlickityHorz);

  //     window.addEventListener('resize', () => {
  //       updateNavChildren(lightboxNavFlickity);
  //       updateNavChildren(lightboxNavFlickityHorz);
  //     })
  //   }
  //   return (lightboxNavFlickity, lightboxNavFlickityHorz) => {
  //     window.removeEventListener('resize', () => {
  //       updateNavChildren(lightboxNavFlickity);
  //       updateNavChildren(lightboxNavFlickityHorz);
  //     })
  //   }
  // }, [showLightbox]);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: wrapper,
    className: `ter-image-gallery ${paddingClass ? paddingClass : ''}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, (0, _ImageGalleryMethods.renderGallery)(content, type, thumbnailWrapper, currentImage, setCurrentImage, currentThumb, setCurrentThumb, setShowLightbox, noButton, sliderQty)), !noButton && (0, _ImageGalleryMethods.renderLightbox)(showLightbox, lightboxNav, content, lightboxNavHorz, setShowLightbox, lightboxMain));
};
var _default = ImageGallery;
exports.default = _default;
ImageGallery.propTypes = {
  content: _propTypes.default.shape({
    images: _propTypes.default.array,
    thumbnailAlignment: _propTypes.default.bool
  }),
  paddingClass: _propTypes.default.string,
  type: _propTypes.default.string
};